import React, { useEffect, useRef, useState } from "react";
import {
	ErrorNotiLogin,
	FomrmLoginButton,
	FomrmLoginCreateOne,
	FomrmLoginCreateOneText,
	FomrmLoginCreateOneWrap,
	FomrmLoginInput,
	FomrmLoginInput2,
	FomrmLoginWrap,
	ForgotYourPassword,
	NoteErrorNotiLogin,
} from "../styled/LoginStyles";
import useLogin from "../hook/useLogin";
import useForgot from "../hook/useForgot";

export default function FomrmForgotPass(props: {
	setOpenDialog: (value: boolean) => void;
	setOpenDialogLogin: (value: boolean) => void;
}) {
	const [loading, setLoading] = useState(false);
	const { doForgot } = useForgot({ setOpenDialog: props.setOpenDialog, setLoading: setLoading });
	const [email, setEmail] = useState("");

	const handleLogin = async () => {
		if (!email) {
			return;
		}
		setLoading(true);
		await doForgot(email);
		setLoading(false);
	};

	const handleCreateOne = async () => {
		props.setOpenDialogLogin(true);
		props.setOpenDialog(false);
	};

	return (
		<FomrmLoginWrap>
			<FomrmLoginInput
				placeholder="Email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						handleLogin();
					}
				}}
			/>
			<FomrmLoginButton
				onClick={handleLogin}
				disabled={loading}
				$loading={loading}>
				{loading ? "Logging in..." : "Send"}
			</FomrmLoginButton>
			<FomrmLoginCreateOneWrap>
				<FomrmLoginCreateOneText>Don’t have an account?</FomrmLoginCreateOneText>
				<FomrmLoginCreateOne onClick={handleCreateOne}>Create One</FomrmLoginCreateOne>
			</FomrmLoginCreateOneWrap>
		</FomrmLoginWrap>
	);
}
